<template>
    <div style="padding: 20px;">
        <!-- 搜索栏 -->
        <div style="display: flex; gap: 10px; margin-bottom: 20px; align-items: center;">
            <el-input v-model="searchPlate" placeholder="请输入车牌号" style="width: 200px;" clearable @keyup.enter="handleSearch" @clear="handleSearch"></el-input>
            <el-button type="primary" @click="handleSearch">搜索</el-button>
            <el-button @click="handleReset">重置</el-button>
            <el-select v-model="effectFilter" placeholder="生效状态" clearable style="width: 120px; margin-left: 10px;" @change="handleSearch">
                <el-option label="已生效" value="effective"></el-option>
                <el-option label="未生效" value="ineffective"></el-option>
            </el-select>
            <el-button type="success" @click="openAdd" style="margin-left: auto;">新增保险</el-button>
        </div>

        <!-- 保险列表 -->
        <el-table :data="filteredData" border style="width: 100%;" v-loading="loading">
            <el-table-column prop="plateNumber" label="车牌号" align="center" width="120"></el-table-column>
            <el-table-column prop="ownerName" label="车主" align="center" width="100"></el-table-column>
            <el-table-column prop="company" label="保险公司" align="center" width="150"></el-table-column>
            <el-table-column prop="policyNo" label="保单号" align="center" width="180"></el-table-column>
            <el-table-column prop="startDate" label="投保日" align="center" width="120" :formatter="dateFormatter"></el-table-column>
            <el-table-column prop="expireDate" label="到期日" align="center" width="120" :formatter="dateFormatter"></el-table-column>
            <el-table-column label="险种" align="center" min-width="200">
                <template #default="scope">
                    <span v-if="scope.row.details && scope.row.details.length">
                        {{ scope.row.details.map(d => d.insuranceType + (d.amount ? '(' + d.amount + '元)' : '')).join('、') }}
                    </span>
                    <span v-else>-</span>
                </template>
            </el-table-column>
            <el-table-column label="状态" align="center" width="80">
                <template #default="scope">
                    <el-tag :type="isEffective(scope.row) ? 'success' : 'info'" size="small">
                        {{ isEffective(scope.row) ? '已生效' : '未生效' }}
                    </el-tag>
                </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="150" fixed="right">
                <template #default="scope">
                    <el-button type="primary" size="small" link @click="openEdit(scope.row)">编辑</el-button>
                    <el-button type="danger" size="small" link @click="handleDelete(scope.row)" :disabled="isEffective(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div style="display: flex; justify-content: flex-end; margin-top: 20px;">
            <el-pagination
                v-model:current-page="pageNum"
                v-model:page-size="pageSize"
                :page-sizes="[10, 20, 50]"
                :total="total"
                layout="total, sizes, prev, pager, next, jumper"
                @size-change="handleSizeChange"
                @current-change="loadList"
            ></el-pagination>
        </div>

        <!-- 新增/编辑弹窗 -->
        <el-dialog v-model="dialogVisible" :title="form.id ? '编辑保险' : '新增保险'" width="750px" destroy-on-close>
            <el-form label-width="100px">
                <!-- 车辆选择（新增时） -->
                <template v-if="!form.id">
                    <el-divider content-position="left">选择车辆</el-divider>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="车牌号" required>
                                <div style="display: flex; gap: 10px;">
                                    <el-input v-model="vehicleSearchPlate" placeholder="请输入车牌号" @keyup.enter="searchVehicle"></el-input>
                                    <el-button type="primary" @click="searchVehicle" :loading="searching">查找</el-button>
                                </div>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12" v-if="selectedVehicle">
                            <el-form-item label="车辆信息">
                                <span>{{ selectedVehicle.plateNumber }}（{{ selectedVehicle.userName || '-' }}）</span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <div v-if="vehicleOptions.length > 1" style="margin: 0 0 15px 100px;">
                        <el-select v-model="selectedVehicleId" placeholder="多辆匹配，请选择" style="width: 400px;" @change="onVehicleSelect">
                            <el-option v-for="v in vehicleOptions" :key="v.id" :label="v.plateNumber + '（' + (v.userName || '-') + '）VIN:' + (v.vin || '-')" :value="v.id"></el-option>
                        </el-select>
                    </div>
                    <!-- 选中车辆后显示车架号 -->
                    <el-row :gutter="20" v-if="selectedVehicle">
                        <el-col :span="24">
                            <el-form-item label="车架号">
                                <span style="color: #409EFF; font-weight: 600;">{{ selectedVehicle.vin || '无' }}</span>
                                <span v-if="!selectedVehicle.vin" style="color: #F56C6C; margin-left: 10px;">车架号为空，无法新增保险</span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </template>

                <!-- 保险信息 -->
                <el-divider content-position="left">保险信息</el-divider>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="保险公司" required>
                            <el-input v-model="form.company" placeholder="请输入"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="保单号" required>
                            <el-input v-model="form.policyNo" placeholder="请输入"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="投保日" required>
                            <el-date-picker v-model="form.startDate" type="datetime" value-format="YYYY-MM-DD HH:mm:ss" :default-time="defaultTime" style="width: 100%;" :disabled="!!form.id && isEffective(form)" placeholder="选择投保日期"></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="到期日" required>
                            <el-date-picker v-model="form.expireDate" type="datetime" value-format="YYYY-MM-DD HH:mm:ss" :default-time="defaultTime" style="width: 100%;" placeholder="选择到期日期"></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="备注">
                            <el-input v-model="form.remark" type="textarea" :rows="2"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <!-- 险种明细 -->
                <el-divider content-position="left">险种明细</el-divider>
                <div style="margin-bottom: 10px;">
                    <el-button type="primary" size="small" @click="addDetail">添加险种</el-button>
                </div>
                <el-table :data="details" border size="small" empty-text="请添加险种">
                    <el-table-column label="险种类型" align="center" min-width="150">
                        <template #default="scope">
                            <el-select v-model="scope.row.insuranceType" placeholder="请选择" size="small" @change="onTypeChange(scope.$index)">
                                <el-option label="交强险" value="交强险"></el-option>
                                <el-option label="车船税" value="车船税"></el-option>
                                <el-option label="商业险" value="商业险"></el-option>
                                <el-option label="第三者责任险" value="第三者责任险"></el-option>
                                <el-option label="车损险" value="车损险"></el-option>
                                <el-option label="盗抢险" value="盗抢险"></el-option>
                                <el-option label="不计免赔" value="不计免赔"></el-option>
                                <el-option label="车上人员责任险" value="车上人员责任险"></el-option>
                                <el-option label="玻璃单独破碎险" value="玻璃单独破碎险"></el-option>
                                <el-option label="自燃损失险" value="自燃损失险"></el-option>
                                <el-option label="涉水损失险" value="涉水损失险"></el-option>
                            </el-select>
                        </template>
                    </el-table-column>
                    <el-table-column label="保费金额(元)" align="center" width="150">
                        <template #default="scope">
                            <el-input-number v-model="scope.row.amount" :controls="false" :min="0" :precision="2" size="small" style="width: 120px;"></el-input-number>
                        </template>
                    </el-table-column>
                    <el-table-column label="备注" align="center" min-width="150">
                        <template #default="scope">
                            <el-input v-model="scope.row.remark" size="small" placeholder="可选"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" align="center" width="80">
                        <template #default="scope">
                            <el-button type="danger" size="small" link @click="removeDetail(scope.$index)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-form>
            <template #footer>
                <el-button @click="dialogVisible = false">取消</el-button>
                <el-button type="primary" @click="handleSave">保存</el-button>
            </template>
        </el-dialog>
    </div>
</template>

<script setup>
import { ref, reactive, onMounted, watch, computed } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { request } from '@/util/globalContext'

// 列表相关
const searchPlate = ref('')
const tableData = ref([])
const loading = ref(false)
const pageNum = ref(1)
const pageSize = ref(10)
const total = ref(0)
const effectFilter = ref('')

// 日期格式化（把T换成空格，显示 yyyy-MM-dd HH:mm:ss）
const dateFormatter = (row, column, value) => {
    if (!value) return '-'
    return String(value).replace('T', ' ')
}

// 按生效状态过滤
const filteredData = computed(() => {
    if (!effectFilter.value) return tableData.value
    return tableData.value.filter(row => {
        const effective = isEffective(row)
        return effectFilter.value === 'effective' ? effective : !effective
    })
})

// 弹窗相关
const dialogVisible = ref(false)
const form = reactive({
    id: null,
    vehicleId: null,
    company: '',
    policyNo: '',
    startDate: '',
    expireDate: '',
    remark: ''
})
const details = ref([])

// 车辆搜索相关（新增时）
const vehicleSearchPlate = ref('')
const selectedVehicle = ref(null)
const selectedVehicleId = ref(null)
const vehicleOptions = ref([])
const searching = ref(false)

// 日期选择器默认时间 00:00:00
const defaultTime = new Date(2000, 0, 1, 0, 0, 0)

// 监听投保日变化，自动计算到期日 = 投保日下一年同日 00:00:00
watch(() => form.startDate, (newVal) => {
    if (newVal) {
        const dateStr = newVal.split(' ')[0]
        const start = new Date(dateStr)
        start.setFullYear(start.getFullYear() + 1)
        form.expireDate = start.toISOString().split('T')[0] + ' 00:00:00'
    }
})

// 判断保险是否已生效（投保日 <= 当前日期）
const isEffective = (insurance) => {
    if (!insurance.startDate) return false
    const startDate = String(insurance.startDate).split(' ')[0]
    const today = new Date().toISOString().split('T')[0]
    return startDate <= today
}

// 加载列表
const loadList = async () => {
    loading.value = true
    try {
        const res = await request.get('/wxapi/getInsuranceList', {
            params: {
                pageNum: pageNum.value,
                pageSize: pageSize.value,
                plateNumber: searchPlate.value || undefined
            }
        })
        if (res.code === 200) {
            const data = res.data || {}
            tableData.value = data.list || []
            total.value = data.total || 0
        }
    } catch (error) {
        console.error('加载列表失败', error)
    } finally {
        loading.value = false
    }
}

// 搜索
const handleSearch = () => {
    pageNum.value = 1
    loadList()
}

// 重置
const handleReset = () => {
    searchPlate.value = ''
    pageNum.value = 1
    loadList()
}

// 切换每页条数
const handleSizeChange = () => {
    pageNum.value = 1
    loadList()
}

// 查找车辆（新增时）
const searchVehicle = async () => {
    if (!vehicleSearchPlate.value) {
        ElMessage.warning('请输入车牌号')
        return
    }
    searching.value = true
    try {
        const res = await request.get('/wxapi/getVehicleAuditList', {
            params: {
                pageNum: 1,
                pageSize: 20,
                plateNumber: vehicleSearchPlate.value,
                status: 2
            }
        })
        if (res.code === 200) {
            const list = res.data?.records || []
            if (list.length === 0) {
                ElMessage.warning('未找到匹配的已绑定车辆')
                selectedVehicle.value = null
                vehicleOptions.value = []
            } else if (list.length === 1) {
                selectedVehicle.value = list[0]
                form.vehicleId = list[0].id
                vehicleOptions.value = []
                if (!list[0].vin) {
                    ElMessage.warning('该车辆车架号为空，无法新增保险')
                }
            } else {
                vehicleOptions.value = list
                selectedVehicle.value = null
                ElMessage.info('找到多辆匹配车辆，请选择')
            }
        }
    } catch (error) {
        ElMessage.error('查找车辆失败')
    } finally {
        searching.value = false
    }
}

// 选择车辆（多辆匹配时）
const onVehicleSelect = (vehicleId) => {
    const v = vehicleOptions.value.find(item => item.id === vehicleId)
    if (v) {
        selectedVehicle.value = v
        form.vehicleId = v.id
    }
}

// 新增
const openAdd = () => {
    Object.assign(form, {
        id: null,
        vehicleId: null,
        company: '',
        policyNo: '',
        startDate: '',
        expireDate: '',
        remark: ''
    })
    details.value = []
    vehicleSearchPlate.value = ''
    selectedVehicle.value = null
    selectedVehicleId.value = null
    vehicleOptions.value = []
    dialogVisible.value = true
}

// 编辑
const openEdit = (row) => {
    Object.assign(form, {
        id: row.id,
        vehicleId: null,
        company: row.company || '',
        policyNo: row.policyNo || '',
        startDate: row.startDate || '',
        expireDate: row.expireDate || '',
        remark: row.remark || ''
    })
    details.value = (row.details || []).map(d => ({ ...d }))
    dialogVisible.value = true
}

// 添加险种
const addDetail = () => {
    details.value.push({
        insuranceType: '',
        amount: null,
        remark: ''
    })
}

// 险种变化时自动补充配对险种
const onTypeChange = (index) => {
    const current = details.value[index]
    if (!current.insuranceType) return
    const types = details.value.map(d => d.insuranceType)
    // 选了交强险，自动补充车船税
    if (current.insuranceType === '交强险' && !types.includes('车船税')) {
        details.value.push({ insuranceType: '车船税', amount: null, remark: '' })
    }
    // 选了车船税，自动补充交强险
    if (current.insuranceType === '车船税' && !types.includes('交强险')) {
        details.value.push({ insuranceType: '交强险', amount: null, remark: '' })
    }
}

// 删除险种
const removeDetail = (index) => {
    details.value.splice(index, 1)
}

// 保存
const handleSave = async () => {
    if (!form.id && !form.vehicleId) {
        ElMessage.warning('请先查找并选择车辆')
        return
    }
    if (!form.id && selectedVehicle.value && !selectedVehicle.value.vin) {
        ElMessage.warning('该车架号为空，无法新增保险')
        return
    }
    if (!form.company) {
        ElMessage.warning('请输入保险公司')
        return
    }
    if (!form.policyNo) {
        ElMessage.warning('请输入保单号')
        return
    }
    if (!form.startDate) {
        ElMessage.warning('请选择投保日')
        return
    }
    if (!form.expireDate) {
        ElMessage.warning('请选择到期日')
        return
    }
    // 校验：交强险和车船税必须成对出现
    const types = details.value.map(d => d.insuranceType).filter(t => t)
    const hasJq = types.includes('交强险')
    const hasCcs = types.includes('车船税')
    if (hasJq && !hasCcs) {
        ElMessage.warning('买了交强险必须同时买车船税')
        return
    }
    if (hasCcs && !hasJq) {
        ElMessage.warning('买了车船税必须同时买交强险')
        return
    }

    try {
        const res = await request.post('/wxapi/saveInsuranceInfo', {
            id: form.id,
            vehicleId: form.vehicleId,
            company: form.company,
            policyNo: form.policyNo,
            startDate: form.startDate,
            expireDate: form.expireDate,
            remark: form.remark,
            details: details.value
        })
        if (res.code === 200) {
            ElMessage.success('保存成功')
            dialogVisible.value = false
            loadList()
        } else {
            ElMessage.error(res.msg || '保存失败')
        }
    } catch (error) {
        ElMessage.error('保存失败')
    }
}

// 删除
const handleDelete = async (row) => {
    try {
        await ElMessageBox.confirm('确定删除该保险记录？', '提示', {
            confirmButtonText: '确认',
            cancelButtonText: '取消',
            type: 'warning'
        })
        const res = await request.post('/wxapi/deleteInsurance', null, { params: { insuranceId: row.id } })
        if (res.code === 200) {
            ElMessage.success('删除成功')
            loadList()
        } else {
            ElMessage.error(res.msg || '删除失败')
        }
    } catch (error) {
        if (error !== 'cancel') {
            ElMessage.error('删除失败')
        }
    }
}

onMounted(() => {
    loadList()
})
</script>
